import React from 'react';
import PropTypes from 'prop-types';
import css from './CwPodCol.scss';
import cx from 'classnames';

const CwPodCol = (props) => {
  const getSectionHeader = () => {
    if (props.sectionHeader || props.ghostSectionHeader) {
      return (
        <div className={cx(css.sectionHeader, { [css.ghostSectionHeader]: props.ghostSectionHeader })}>
          {props.ghostSectionHeader ? 'expect(jkenoyer).toBeFalsy()' : props.sectionHeader}
          {props.sectionHeaderElements}
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ flexGrow: props.colSpan }}
      className={cx(css.podCol, props.sectionHeader ? css.podColWithSectionHeader : css.podColWithoutSectionHeader)}>
      {getSectionHeader()}
      {props.children}
    </div>
  );
};

CwPodCol.propTypes = {
  sectionHeader: PropTypes.string,
  ghostSectionHeader: PropTypes.bool,
  sectionHeaderElements: PropTypes.arrayOf(PropTypes.element),
  colSpan: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

CwPodCol.defaultProps = {
  colSpan: 1
};

export default CwPodCol;


// WEBPACK FOOTER //
// ./src/components/cwpod/CwPodCol.jsx